<template>
  <div id="sustainabilityDesktop">
    <div v-if="!getMobile" id="navigation">
      <div style="position: relative;">
        <Navigation />
      </div>
    </div>
    <div v-if="getMobile">
      <NavigationMobile />
    </div>

    <div v-if="!getMobile">
      <div id="A_intro">
        <video autoplay muted loop id="video">
          <source src="./../../public/video/bees.mp4" type="video/mp4">
        </video>
        <div id="introTextView" class="centerElement">
          <div>
          </div>
          <div>
            <h1 style="color: white; text-shadow: 0 0 2px var(--accentColor); font-size: 4em !important;">
              {{getText.title}}
            </h1>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>

    <!-- <img  src="./../../public/img/sustainabilityMobileTop.jpeg" style="height: 100vh; min-height: 670px; max-width: 100vw; position: absolute; top: 0; left: 0; z-index: 0;"/> -->

<div style="overflow: hidden;">
    <video v-if="getMobile" autoplay muted loop id="video">
      <source src="./../../public/video/bees.mp4" type="video/mp4">
    </video>
  </div>


    <div v-if="getMobile" style="height: 100vh; min-height: 600px; position: absolute; top: 0px;">
          <div id="introTextViewMobile" class="mobile">
            <h1 style="position: relative; top: 40px; color: white; text-align: center; text-shadow: 0 0 2px var(--accentColor); font-size: 3em !important;">
              {{getText.title}}
            </h1>
            <!-- <div id="backgroundShade" style="margin: auto;">
              <img src="./../../public/icons/logo.svg" width="80%" style="margin: 0 10%"/>
              <h1>
                {{getText.title}}
              </h1>
              <h3>
                <br />
                {{getText.subTitle1}}
                <br />
                {{getText.subTitle2}}
                <br />
                {{getText.subTitle3}}
              </h3>
            </div> -->
          </div>
          <div style="height: 20vh">
        </div>
      </div>

    <div class="fullWidthElement"
        :class="{numbers : !getMobile, mobileNumbers : getMobile}">
        <h1  class="mobile">
          {{getText.introTitle}}
        </h1>
      </div>

    <div :class="{centerElement : !getMobile, mobile : getMobile}" style="margin: 40px 0;">
      <div v-if="!getMobile">
      </div>
      <div>
        <h3>
          {{getText.intro1}}<br/>
          {{getText.intro2}}
        </h3>
      </div>
      <div v-if="!getMobile">
      </div>
    </div>

    <div class="leftRightElement slideELement" v-if="!getMobile">
      <div style="position:relative;">
        <div class="stickyAnimation" >
          <img src="/img/rho-17-bienenwachs-01.jpeg" width="100%"/>
        </div>
      </div>
      <div style="margin-bottom: -100vh;">
        <div class="text">
          <p style="text-align: left;">
            {{getText.waxText1}}
          </p>
          <p style="text-align: left;">
            {{getText.waxText2}}
          </p>
          <p style="text-align: left;">
            {{getText.waxBulletsTitle}}
          </p>
          <ul style="text-align:left; list-style-type: circle;">
            <li v-for="(bullet, index) in getText.waxBullets" :key="index">
              <b>{{bullet}}</b>
            </li>
          </ul>
          <br/>
          <p style="text-align: left;">
            {{getText.waxText3}}
          </p>
        </div>
      </div>
    </div>

    <div v-if="getMobile" style="width: 100%; height: 100vw;">
      <img src="./../../public/img/rho-17-bienenwachs-01.jpeg" width="100%" />
    </div>

    <div v-if="getMobile" class="mobile">
      <div class="text">
        <p style="text-align: left;">
          {{getText.waxText1}}
        </p>
        <p style="text-align: left;">
          {{getText.waxText2}}
        </p>
        <p style="text-align: left;">
          {{getText.waxBulletsTitle}}
        </p>
        <ul style="text-align:left; list-style-type: circle;">
          <li v-for="(bullet, index) in getText.waxBullets" :key="index">
            <b>{{bullet}}</b>
          </li>
        </ul>
        <br/>
        <p style="text-align: left;">
          {{getText.waxText3}}
        </p>
      </div>
    </div>


    <div class="leftRightElement slideELement" v-if="!getMobile">
      <div style="margin-bottom: -100vh;">
        <div class="text">
          <h1 style="text-align: right;">
            <span class="mediumLineHeight">{{getText.friederTitle}}</span>
          </h1>
          <p style="text-align: right;">
            {{getText.friederText1}}
          </p>
          <p style="text-align: right;">
            {{getText.friederText2}}
          </p>
          <p style="text-align: right;">
            {{getText.friederText3}}
          </p>
        </div>
      </div>
      <div style="position:relative;">
        <div class="stickyAnimation" >
          <img src="/img/rho-17-bienenwachs-02.jpeg" width="100%"/>
        </div>
      </div>
    </div>

    <div v-if="getMobile" style="width: 100%; height: 100vw;">
      <img src="./../../public/img/rho-17-bienenwachs-02.jpeg" width="100%" />
    </div>

    <div v-if="getMobile" class="mobile">
      <div class="text">
        <h1 style="text-align: left;">
          <span class="mediumLineHeight">{{getText.friederTitle}}</span>
        </h1>
        <p style="text-align: left;">
          {{getText.friederText1}}
        </p>
        <p style="text-align: left;">
          {{getText.friederText2}}
        </p>
        <p style="text-align: left;">
          {{getText.friederText3}}
        </p>
      </div>
    </div>

    <div class="leftRightElement slideELement" v-if="!getMobile">
      <div style="position:relative;">
        <div class="stickyAnimation" >
          <img src="/img/rho-17-honig.jpeg" width="100%"/>
        </div>
      </div>
      <div>
        <div class="text">
          <h1 style="text-align: left;">
            <span class="mediumLineHeight">{{getText.honeyTitle}}</span>
          </h1>
          <p style="text-align: left;">
            {{getText.honeyText}}
          </p>
          <div id="honeyIcons">
            <div>
              <img src="./../../public/icons/honeyYummy.svg" style="position: relative; left: 0; bottom: 15px;" height="90px"/>
              <p>{{getText.honeyBullets[0]}}</p>
            </div>
            <div>
              <img src="./../../public/icons/honeyCreamy.svg" style="position: relative; left: 0; bottom: 15px;" height="90px"/>
              <p>{{getText.honeyBullets[1]}}</p>
            </div>
            <div>
              <img src="./../../public/icons/honeySun.svg" style="position: relative; left: 0; bottom: 15px;" height="90px"/>
              <p>{{getText.honeyBullets[2]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="getMobile" style="width: 100%; height: 100vw;">
      <img src="./../../public/img/rho-17-honig.jpeg" width="100%" />
    </div>

    <div v-if="getMobile" class="mobile" style="margin-bottom: 80px;">
      <div class="text" style="position: relative;">
        <h1 style="text-align: left;">
          <span class="mediumLineHeight">{{getText.honeyTitle}}</span>
        </h1>
        <p style="text-align: left;">
          {{getText.honeyText}}
        </p>
        <div class="honeyIconsMobile">
          <img src="./../../public/icons/honeyYummy.svg" height="90px"/>
          <span style="position: relative; top: 30px; text-align: left; left: 10px;" >{{getText.honeyBullets[0]}}</span>
        </div>
        <div class="honeyIconsMobile">
          <img src="./../../public/icons/honeyCreamy.svg" height="90px"/>
          <span style="position: relative; top: 30px; text-align: left; left: 10px;" >{{getText.honeyBullets[1]}}</span>
        </div>
        <div class="honeyIconsMobile">
          <img src="./../../public/icons/honeySun.svg" height="90px"/>
          <span style="position: relative; top: 30px; text-align: left; left: 10px;" >{{getText.honeyBullets[2]}}</span>
        </div>
      </div>
    </div>

    <Footer/>

  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import Footer from '@/components/Footer.vue'
import NavigationMobile from '@/components/NavigationMobile.vue'

export default {
  name: 'SustainabilityDesktop',
  components: {
    Footer,
    Navigation,
    NavigationMobile
  },
  data() {
    return{
    }
   },
   beforeDestroy () {
    },
    mounted (){
      this.$store.dispatch("setNavbarActive", 2);
      window.scrollTo(0, 0)
    },
    watch: {
    },
    computed: {
      getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
      getText(){return this.$store.getters.getText.bees;},
    },
   methods: {
   }
}
</script>

<style scoped>
  .mobile{
    padding: 0 10% 0 10%;
  }
  #A_intro{
    /* background-image: url('./../../public/img/sustainabilityDesktopTop.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    background-position: bottom center; */
    min-height: 105vh;
    position: relative;
  }
  #myVideo {
    position: absolute;
  right: 0;
  top: var(--desktopNavigationHeight);
}
  #introTextView{
    position: absolute;
    text-align: center;
    width: 100%;
    top: 35%;

    /* position: absolute;
    text-align: left;
    width: 500px;
    top: 140px;
    right: 150px;
    padding: 50px;
    height: 250px;
    background-color: #FFFFFFAA */
  }
  #introTextViewMobile{
    position: absolute;
    text-align: left;
    width: 300px;
    top: 150px;
    height: 600px;
    margin-left: calc((100vw - 300px)/2)
  }
  #homeDesktop{
    width: 100vw;
  }
  /* #logoView{
    height: 40vh;
    padding-top: 100px;
  } */
  #honeyIcons{
    position: relative;
    top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .honeyIconsMobile{
    position: relative;
    display: grid;
    grid-template-columns: 100px 1fr;
  }

  #logoView{
    height: 50vh;
    padding-top: 20vh;
  }
  #backgroundShade{
    padding: 30px 30px 50px 30px;
    width: 80vw;
    height: 520px;
    background-color: #FFFFFFAA;
  }
  #infoWoodTextView{
    height: 400px;
  }
  #infoAboutView{
    height: 400px;
    margin-top: calc(100vh - var(--desktopNavigationHeight));
  }
  #infoSuastainabilityView{
    height: 400px;
  }
  .numbers{
    position: relative;
    top: 20px;
    margin-top:20px;
  }
  .mobileNumbers{
    position: relative;
    margin-top: 30px;
  }
  .slideELement{
    min-height: calc(100vh - var(--desktopNavigationHeight));
  }

  .slidePicture{
    height: calc(100vh - var(--desktopNavigationHeight));
  }

  .stickyAnimation{
    position:sticky;
    top: var(--desktopNavigationHeight);
  }

  .inFromLeft{
    position: absolute;
    left: -100%;
    width: 100%;
  }
  .inFromRight{
    position: absolute;
    left: 100%;
    width: 100%;
  }
  .animationSlidein {
    animation: slidein 2s forwards;
  }
  .text{
    padding: 100px 10% 0 10%;
  }
  .bigLineHeight{
    display: inline-block;
    margin-bottom: 100px;
  }
  .footerDesktop{
    position: relative;
    top: 100px;
  }
  .mediumLineHeight{
    display: inline-block;
    margin-bottom: 50px;
  }

  @keyframes slidein {
    100% { left: 0; }
  }

#video{
  height: 100%;
     width: 177.77777778vh; /* 100 * 16 / 9 */
     min-width: 100%;
     min-height: 56.25vw; /* 100 * 9 / 16 */
  }

</style>
